__turbopack_context__.v({
  "block": "Filter-module-scss-module__fFnUeG__block",
  "clear": "Filter-module-scss-module__fFnUeG__clear",
  "clearWrapper": "Filter-module-scss-module__fFnUeG__clearWrapper",
  "clickable": "Filter-module-scss-module__fFnUeG__clickable",
  "copy": "Filter-module-scss-module__fFnUeG__copy",
  "filter": "Filter-module-scss-module__fFnUeG__filter",
  "filterLabel": "Filter-module-scss-module__fFnUeG__filterLabel",
  "filterMasthead": "Filter-module-scss-module__fFnUeG__filterMasthead",
  "filterMastheadCta": "Filter-module-scss-module__fFnUeG__filterMastheadCta",
  "filterMastheadEyebrow": "Filter-module-scss-module__fFnUeG__filterMastheadEyebrow",
  "filterMastheadHeadline": "Filter-module-scss-module__fFnUeG__filterMastheadHeadline",
  "filterSelect": "Filter-module-scss-module__fFnUeG__filterSelect",
  "filterSelectDisplay": "Filter-module-scss-module__fFnUeG__filterSelectDisplay",
  "filterSelectElement": "Filter-module-scss-module__fFnUeG__filterSelectElement",
  "filterSelectIcon": "Filter-module-scss-module__fFnUeG__filterSelectIcon",
  "filterSelectWrapper": "Filter-module-scss-module__fFnUeG__filterSelectWrapper",
  "filters": "Filter-module-scss-module__fFnUeG__filters",
  "hasSelection": "Filter-module-scss-module__fFnUeG__hasSelection",
  "isHidden": "Filter-module-scss-module__fFnUeG__isHidden",
  "root": "Filter-module-scss-module__fFnUeG__root",
  "search": "Filter-module-scss-module__fFnUeG__search",
  "searchIcon": "Filter-module-scss-module__fFnUeG__searchIcon",
  "theme--all": "Filter-module-scss-module__fFnUeG__theme--all",
  "theme--block": "Filter-module-scss-module__fFnUeG__theme--block",
  "theme--foodService": "Filter-module-scss-module__fFnUeG__theme--foodService",
});
